const normalize = (value) => (value || '').trim().toLowerCase();

const isBeneficiaireAyantDroit = (beneficiaire, ayantDroit) =>
  normalize(beneficiaire) === normalize(ayantDroit);

const getAccountDestination = (beneficiaire, isOwnAccount) =>
  isOwnAccount ? 'votre compte' : `le compte de ${beneficiaire}`;

const getRepaymentMessage = (reglement, ayantDroit) => {
  const { dateMiseEnBanque, beneficiaire } = reglement || {};
  const isOwnAccount = isBeneficiaireAyantDroit(beneficiaire, ayantDroit);
  const accountDestination = getAccountDestination(beneficiaire, isOwnAccount);

  if (dateMiseEnBanque) {
    return `Remboursement effectué le ${dateMiseEnBanque} sur ${accountDestination}.`;
  }

  return `Remboursement à venir sur ${accountDestination}.`;
};

export default getRepaymentMessage;
